//original js
//ページ移動前のURLにハッシュがついている場合、移動後もそのハッシュを引き継ぐ

  document.addEventListener('DOMContentLoaded', () => {
  const currentHash = window.location.hash; // 現在のURLのフラグメント（例: #search-article）

  if (currentHash) {
    // ページネーションリンクを更新
    document.querySelectorAll('.pagination__item.link').forEach(link => {
      const url = new URL(link.href);
      url.hash = currentHash.slice(1); // フラグメントを設定
      link.href = url.toString();
    });
  }
});